export { default } from './ModalSeguros';
